<template>
  <div>
    <div class="file-head">
      <div class="file-step-wrapper">
        <div class="file-step-arr">
          <div class="file-step-item" v-for="(item, index) in gradeList" :key="index" @click="goBackStep(index)">
            <div class="file-step-item-title">{{ item.title }}</div>
            <img src="@/assets/ic_right.png" alt="" />
          </div>
          <div class="file-stop-last" :class="{'file-stop-last-active': gradeList.length == 0}">{{ currentDir.title }}</div>
        </div>
      </div>
      <div class="sort-body">
        <div class="sort-title" @mouseenter="showSort" @mouseleave="hideSort">{{ orderbyName }}</div>
        <div class="sort-icon" :class="{'sort-icon-active': sort == 'desc'}" @click="changeSort"><img src="@/assets/ic_sort.png" alt=""></div>
        <div class="sort-options" 
              v-if="sortIsHovered || sortIsHoveredTemp" 
              @mouseenter="showSortTemp" 
              @mouseleave="hideSortTemp"
              :style="{ top: sortPosition.top + 'px', left: sortPosition.left + 'px' }">
          <div class="sort-options-item" 
              :class="{'sort-options-item-title-select': orderby == item.value}" 
              v-for="(item, index) in orderByOptions" :key="index"
              @click="clickSort(item.value, item.label)">
            <div class="sort-options-item-title">{{ item.label }}</div>
            <div class="sort-options-item-icon" v-if="orderby == item.value">
              <img src="@/assets/ic_sort_select.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="file-tab">
      <div class="file-tab-title">
        <div class="file-tab-title-body">
          <div class="file-tan-title-ic" @click="clickSelectedAll">
            <img v-if="!selectedAll" src="@/assets/ic_selected_n.png" alt="" />
            <img v-else src="@/assets/ic_selected_y.png" alt="" />
          </div>
          <div class="file-title">文件</div>
        </div>
      </div>
    </div>
    
    <!-- 文件列表 -->
    <div class="tab-content-file" ref="scrollContainer" v-if="currentDir.subs.length > 0">
      <file-item @clickSelectedItem="clickSelectedItem" @click.native="clickFileItem(item)" :file-item="item" v-for="(item, index) in currentDir.subs" :key="index"></file-item>
    </div>
    <div ref="scrollContainer" v-else>
      <empty></empty>
    </div>
    
    <!-- 分页器 -->
    <div class="pagination-wrapper" v-if="currentDir.total > formData.pagesize">
      <div class="pagination">
        <button 
          class="page-btn prev-btn" 
          :disabled="formData.page <= 1"
          @click="changePage(formData.page - 1)">
          <span class="arrow-icon">‹</span>
          上一页
        </button>
        
        <!-- 页码按钮 -->
        <div class="page-numbers">
          <button 
            v-for="pageNum in visiblePages" 
            :key="pageNum"
            class="page-number-btn"
            :class="{ 'active': pageNum === formData.page, 'ellipsis': pageNum === '...' }"
            @click="pageNum !== '...' ? changePage(pageNum) : null"
            :disabled="pageNum === '...'">
            {{ pageNum }}
          </button>
        </div>
        
        <button 
          class="page-btn next-btn" 
          :disabled="formData.page >= totalPages"
          @click="changePage(formData.page + 1)">
          下一页
          <span class="arrow-icon">›</span>
        </button>
        
        <!-- 页面信息 -->
        <div class="page-info">
          <span>第 {{ formData.page }} 页 / 共 {{ totalPages }} 页</span>
          <span class="total-info">共 {{ currentDir.total }} 个文件</span>
        </div>
        
        <!-- 快速跳转 -->
        <div class="page-jumper">
          <span>跳至</span>
          <input 
            type="number" 
            v-model.number="jumpPage" 
            @keyup.enter="jumpToPage"
            :min="1" 
            :max="totalPages"
            class="jump-input" />
          <span>页</span>
          <button class="jump-btn" @click="jumpToPage">跳转</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { throttle } from 'lodash';
  import { diskIndex, diskSearch } from '@/utils/api/apis.js'
  import fileItem from '../file_item.vue'
  import empty from '@/components/empty.vue';
  
  export default {
    components: {
      fileItem,
      empty
    },
    props: {
      type: {
        type: String,
        required: true
      },
      searchValue: {
        type: String,
        required: true
      },
      dirId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        selectedAll: false,
        jumpPage: 1, // 跳转页码
        formData: {
          dir_id: -1,
          page: 1,
          pagesize: 20,
          orderby: '',
          sort: '',
          source: '',
          type: '',
          word: ''
        },
        currentDir: {
          title: '全部文件',
          subs: [],
          total: 0
        },
        gradeList: [],
        orderByOptions: [
          { label: '综合排序', value: ''},
          { label: '创建日期', value: 'createtime'},
          { label: '文件名称', value: 'name'},
          { label: '文件大小', value: 'size'}
        ],
        orderby: '',
        orderbyName: '综合排序',
        sort: 'desc',
        sortIsHovered: false,
        sortIsHoveredTemp: false,
        sortPosition: { top: 0, left: 0 },
      }
    },
    computed: {
      // 总页数
      totalPages() {
        return Math.ceil(this.currentDir.total / this.formData.pagesize);
      },
      // 可见的页码
      visiblePages() {
        const current = this.formData.page;
        const total = this.totalPages;
        const pages = [];
        
        if (total <= 7) {
          // 总页数小于等于7，显示所有页码
          for (let i = 1; i <= total; i++) {
            pages.push(i);
          }
        } else {
          // 总页数大于7，显示省略号
          pages.push(1);
          
          if (current <= 4) {
            // 当前页在前面
            for (let i = 2; i <= 5; i++) {
              pages.push(i);
            }
            pages.push('...');
            pages.push(total);
          } else if (current >= total - 3) {
            // 当前页在后面
            pages.push('...');
            for (let i = total - 4; i <= total; i++) {
              pages.push(i);
            }
          } else {
            // 当前页在中间
            pages.push('...');
            for (let i = current - 1; i <= current + 1; i++) {
              pages.push(i);
            }
            pages.push('...');
            pages.push(total);
          }
        }
        
        return pages;
      }
    },
    watch: {
      searchValue(newVal) {
        this.formData.word = newVal
        this.formData.page = 1
        this.currentDir.subs = [];
        this.getDiskIndex()
      }
    },
    methods: {
      // 获取文件列表
      async getDiskIndex({isShowLoading = false} = {}) {
        try{
          if (isShowLoading) {
            this.$dialog.loading.show()
          }
          
          var base;
          if (this.formData.word != '') {
            base = await diskSearch(this.formData);
          } else {
            base = await diskIndex(this.formData);
          }
          
          base.data.list.forEach((item) => {
            if (item.data_type != 3) {
              item.selected = this.selectedAll
            }
          });
          
          // 直接替换数据，不再追加
          this.currentDir.subs = base.data.list;
          this.currentDir.total = base.data.total;
          
          this.getSelectItem()
          
          if (isShowLoading) {
            this.$dialog.loading.hide()
          }
        }catch(e){
          if (isShowLoading) {
            this.$dialog.loading.hide()
          }
          this.$toast(e)
          this.$errorLog('tab_file/getDiskIndex', e)
        }
      },
      
      // 分页切换
      changePage(page) {
        if (page < 1 || page > this.totalPages) return;
        
        this.formData.page = page;
        this.jumpPage = page; // 同步跳转输入框
        this.selectedAll = false;
        this.currentDir.subs.forEach(item => {
          item.selected = false;
        });
        
        this.getDiskIndex({isShowLoading: true});
        
        // 滚动到顶部
        this.$nextTick(() => {
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.scrollTop = 0;
          }
        });
      },
      
      // 跳转到指定页
      jumpToPage() {
        const page = parseInt(this.jumpPage);
        if (isNaN(page) || page < 1 || page > this.totalPages) {
          this.$toast('请输入有效的页码');
          this.jumpPage = this.formData.page;
          return;
        }
        this.changePage(page);
      },
      
      clickSelectedAll() {
        this.selectedAll = !this.selectedAll
        this.currentDir.subs.forEach(item => {
          if (item.data_type !== 3) item.selected = this.selectedAll;
        });
        this.getSelectItem()
      },
      
      clickSelectedItem(data) {
        data.selected = !data.selected
        this.selectedAll = this.currentDir.subs
            .filter(item => item.data_type !== 3)
            .every(item => item.selected);
        this.getSelectItem()
      },
      
      async clickFileItem(item) {
        if (item.is_dir != 1) {
          return;
        }
        this.currentDir.subs.forEach(item => {
          if (item.data_type !== 3) item.selected = false;
        });
        this.$emit('changeDirId', item)
        
        this.gradeList.push({
          ...this.currentDir,
          page: this.formData.page,
          id: this.formData.dir_id
        });

        this.currentDir.title = item.title
        this.formData.dir_id = item.id;
        this.formData.page = 1;
        this.jumpPage = 1;
        await this.getDiskIndex({isShowLoading: true});
        
        this.$nextTick(() => {
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.scrollTop = 0;
          }
        });
      },
      
      goBackStep(index) {
        this.selectedAll = false;
        const previousDir = this.gradeList[index];
        this.gradeList = this.gradeList.slice(0, index);
        this.currentDir = previousDir;
        this.formData.page = previousDir.page;
        this.formData.dir_id = previousDir.id || 0;
        this.jumpPage = previousDir.page;
        this.$emit('changeDirId', {id: this.formData.dir_id})
        
        this.getSelectItem()
        this.formData.page = 1
        this.jumpPage = 1;
        this.getDiskIndex()
      },
      
      getSelectItem() {
        var tempArr = [];
        this.currentDir.subs.forEach((item) => {
          if (item.selected) {
            tempArr.push(item)
          }
        })
        this.$emit('selectionList', tempArr)
      },
      
      removeSelectedItem() {
        const filteredItems = this.currentDir.subs.filter(item => !item.selected);
        this.currentDir.subs = filteredItems
      },
      
      cleanAllSelected() {
        this.selectedAll = false;
        this.currentDir.subs.forEach(item => {
          item.selected = false;
        });
        this.getSelectItem()
      },
      
      showSort(event) {
        this.sortIsHovered = true
        const rect = event.target.getBoundingClientRect();
        this.sortPosition = {
          top: rect.bottom + window.scrollY + 6,
          left: rect.left + window.scrollX - 86,
        };
      },
      
      hideSort() {
        setTimeout(() => {
          this.sortIsHovered = false
        }, 500)
      },
      
      showSortTemp() {
        this.sortIsHoveredTemp = true
      },
      
      hideSortTemp() {
        this.sortIsHoveredTemp = false
      },
      
      clickSort(value, label) {
        this.orderby = value
        this.orderbyName = label
        this.sortIsHoveredTemp = false
        this.formData.page = 1;
        this.jumpPage = 1;
        this.formData.orderby = value
        this.getDiskIndex({isShowLoading: true})
      },
      
      changeSort() {
        this.sort = this.sort == 'desc' ? 'asc' : 'desc'
        this.formData.page = 1;
        this.jumpPage = 1;
        this.formData.sort = this.sort
        this.getDiskIndex({isShowLoading: true})
      }
    },
    
    created() {},
    
    mounted() {
      this.formData.type = this.type
      this.formData.word = this.searchValue
      this.formData.dir_id = this.type == '' ? 0 : -1
      this.jumpPage = this.formData.page;
      this.getDiskIndex({isShowLoading: true})
    },
    
    beforeCreate() {},
    beforeMount() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    activated() {}
  }
</script>

<style lang='scss' scoped>
  .file-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    box-sizing: border-box;
    padding: 0 24px;
    gap: 16px;
    .file-step-wrapper {
      position: relative;
      flex: 1;
      width: 0;
      min-width: 0;
      overflow-x: auto;
      overflow-y: hidden;
      
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .file-step-arr {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 100%;
      min-width: min-content;
      .file-step-item {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: bold;
        color: #000;
        .file-step-item-title {
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        cursor: pointer;
        img {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
        }
      }
      .file-step-item:first-child{
        font-size: 18px;
      }
      .file-stop-last {
        font-size: 15px;
        font-weight: bold;
        color: rgba(153, 153, 153, 1);
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .file-stop-last-active {
        font-size: 18px;
      }
    }
    .sort-body {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .sort-title {
        font-size: 16px;
        color: rgba(102, 102, 102, 1);
        margin-right: 10px;
      }
      .sort-icon {
        width: 12px;
        height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 12px;
          height: 19px;
        }
      }
      .sort-icon-active {
        transform: rotate(180deg);
      }
      .sort-options {
        position: absolute;
        width: 172px;
        height: auto;
        background-color: white;
        border-radius: 10px;
        border: 1px solid rgba(204, 204, 204, 1);
        box-sizing: border-box;
        padding: 18px 14px 18px 18px;
        z-index: 100;
        .sort-options-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          color: rgba(102, 102, 102, 1);
          cursor: pointer;
          margin-bottom: 20px;
          .sort-options-item-title {
            font-size: 16px;
            font-weight: bold;
          }
          .sort-options-item-icon {
            width: 14px;
            height: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 14px;
              height: 14px;
            }
          }
        }
        .sort-options-item-title-select {
          color: rgba(74, 131, 255, 1);
        }
        .sort-options-item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  
  .file-tab {
    height: 40px;
    padding: 0 24px;
    .file-tab-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      font-size: 15px;
      font-weight: bold;
      .file-tab-title-body {
        display: flex;
        align-items: center;
        .file-tan-title-ic {
          width: 14px;
          height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 22px;
          img {
            width: 14px;
            height: 14px;
          }
        }
        .file-tan-title-ic:hover {
          cursor: pointer;
        }
      }
    }
  }
  
  .tab-content-file {
    height: calc(100vh - 364px); // 调整高度为分页器留出空间
    overflow-y: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  // 分页器样式
  .pagination-wrapper {
    height: 60px;
    padding: 12px 24px;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
    
    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      height: 100%;
      
      .page-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 12px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background: white;
        cursor: pointer;
        font-size: 13px;
        color: #666;
        transition: all 0.3s;
        
        .arrow-icon {
          font-size: 16px;
          font-weight: bold;
          line-height: 1;
        }
        
        &.prev-btn .arrow-icon {
          margin-right: 2px;
        }
        
        &.next-btn .arrow-icon {
          margin-left: 2px;
        }
        
        &:disabled {
          background: #f5f5f5;
          color: #ccc;
          cursor: not-allowed;
          border-color: #f0f0f0;
          
          .arrow-icon {
            color: #ccc;
          }
        }
        
        &:not(:disabled):hover {
          border-color: #4A83FF;
          color: #4A83FF;
          
          .arrow-icon {
            color: #4A83FF;
          }
        }
      }
      
      .page-numbers {
        display: flex;
        gap: 4px;
        
        .page-number-btn {
          min-width: 32px;
          height: 32px;
          padding: 0;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          background: white;
          cursor: pointer;
          font-size: 13px;
          color: #666;
          transition: all 0.3s;
          
          &.active {
            background: #4A83FF;
            border-color: #4A83FF;
            color: white;
          }
          
          &.ellipsis {
            border: none;
            background: none;
            cursor: default;
            color: #999;
          }
          
          &:not(.active):not(.ellipsis):hover {
            border-color: #4A83FF;
            color: #4A83FF;
          }
        }
      }
      
      .page-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 16px;
        font-size: 12px;
        color: #666;
        
        .total-info {
          font-size: 11px;
          color: #999;
          margin-top: 2px;
        }
      }
      
      .page-jumper {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: #666;
        
        .jump-input {
          width: 50px;
          height: 28px;
          padding: 0 8px;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          text-align: center;
          font-size: 12px;
          
          &:focus {
            outline: none;
            border-color: #4A83FF;
          }
        }
        
        .jump-btn {
          padding: 4px 8px;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          background: white;
          cursor: pointer;
          font-size: 12px;
          color: #666;
          transition: all 0.3s;
          
          &:hover {
            border-color: #4A83FF;
            color: #4A83FF;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/tabs/tab_file.vue